import { client, s3sClient } from "./index";

export const postDeploy = (payload, token) => client.post(`ADD_SHIPMENT`, payload, { headers: { "Authorization": `Bearer ${token}` } });

export const getParts = (token) => client.get(`GET_ASSET_DETAILS`, { headers: { "Authorization": `Bearer ${token}` } });

export const getLocations = (token) => s3sClient.get(`facility/facilities/info`, { headers: { "Authorization": `Bearer ${token}` } });

export const getThirdPartyFacility = (token) => s3sClient.get(`facility/facilities/information`, { headers: { "Authorization": `Bearer ${token}` } });

export const getShipmetList = (token) => client.get(`get_request_details`, { headers: { "Authorization": `Bearer ${token}` } });

export const getRequestById = (payload, token) => client.post(`GET_REQUEST_DETAILS_BY_ID`, payload, { headers: { "Authorization": `Bearer ${token}` } });

export const getEmails = (token) => s3sClient.get(`azure_usermanagment/user/emails`, { headers: { "Authorization": `Bearer ${token}` } });

export const updateStatus = (payload, token) => client.post(`UPDATE_STATUS`, payload, { headers: { "Authorization": `Bearer ${token}` } });

export const updateRequest = (payload, token) => client.post(`UPDATE_REQUEST`, payload, { headers: { "Authorization": `Bearer ${token}` } });

export const deleteAsset = (payload, token) => client.post(`DELETE_ASSET`, payload, { headers: { "Authorization": `Bearer ${token}` } });


export const getAssetStatus = (token) => client.get(`ASSET_STATUS`, { headers: { "Authorization": `Bearer ${token}` } });

export const getRigOptions = (token) => client.get(`ACTIVE_JOBS`, { headers: { "Authorization": `Bearer ${token}` } });

export const getAssetByRig = (token, payload) => client.post(`ASSETS_BY_RIG`, payload,  { headers: { "Authorization": `Bearer ${token}` } });



export const uploadImg = (formData, token) => client.post(`upload_file`, formData, {
  headers: {
    'Content-Type': 'multipart/form-data',
    "Authorization": `Bearer ${token}`
  }
});







